// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see MoneyBrowseViewScreenEvent
 */
export var MoneyBrowseViewScreen = function (_a) {
    var moneyFlowToken = _a.moneyFlowToken, moneyVersion = _a.moneyVersion, contentJsonRepresentation = _a.contentJsonRepresentation;
    return ({
        name: "Money Browse ViewScreen",
        parameters: {
            cdf_entity: "Money",
            cdf_action: "Browse",
            money_flow_token: moneyFlowToken !== undefined && moneyFlowToken !== null ? moneyFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            money_version: moneyVersion !== undefined && moneyVersion !== null ? moneyVersion.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            content_json_representation: contentJsonRepresentation !== undefined && contentJsonRepresentation !== null ? contentJsonRepresentation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see MoneyBrowseViewItemEvent
 */
export var MoneyBrowseViewItem = function (_a) {
    var moneyFlowToken = _a.moneyFlowToken, sectionId = _a.sectionId, sectionIndex = _a.sectionIndex, sectionTotal = _a.sectionTotal, itemId = _a.itemId, itemIndex = _a.itemIndex, absoluteItemIndex = _a.absoluteItemIndex, moneyVersion = _a.moneyVersion;
    return ({
        name: "Money Browse ViewItem",
        parameters: {
            cdf_entity: "Money",
            cdf_action: "Browse",
            money_flow_token: moneyFlowToken !== undefined && moneyFlowToken !== null ? moneyFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            section_id: sectionId !== undefined && sectionId !== null ? sectionId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            section_index: sectionIndex !== undefined && sectionIndex !== null ? sectionIndex.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            section_total: sectionTotal !== undefined && sectionTotal !== null ? sectionTotal.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            item_id: itemId !== undefined && itemId !== null ? itemId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            item_index: itemIndex !== undefined && itemIndex !== null ? itemIndex.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            absolute_item_index: absoluteItemIndex !== undefined && absoluteItemIndex !== null ? absoluteItemIndex.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            money_version: moneyVersion !== undefined && moneyVersion !== null ? moneyVersion.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see MoneyBrowseSelectItemEvent
 */
export var MoneyBrowseSelectItem = function (_a) {
    var moneyFlowToken = _a.moneyFlowToken, sectionId = _a.sectionId, sectionIndex = _a.sectionIndex, sectionTotal = _a.sectionTotal, itemId = _a.itemId, itemIndex = _a.itemIndex, absoluteItemIndex = _a.absoluteItemIndex, tapElement = _a.tapElement, moneyVersion = _a.moneyVersion, action = _a.action;
    return ({
        name: "Money Browse SelectItem",
        parameters: {
            cdf_entity: "Money",
            cdf_action: "Browse",
            money_flow_token: moneyFlowToken !== undefined && moneyFlowToken !== null ? moneyFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            section_id: sectionId !== undefined && sectionId !== null ? sectionId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            section_index: sectionIndex !== undefined && sectionIndex !== null ? sectionIndex.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            section_total: sectionTotal !== undefined && sectionTotal !== null ? sectionTotal.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            item_id: itemId !== undefined && itemId !== null ? itemId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            item_index: itemIndex !== undefined && itemIndex !== null ? itemIndex.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            absolute_item_index: absoluteItemIndex !== undefined && absoluteItemIndex !== null ? absoluteItemIndex.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            tap_element: tapElement !== undefined && tapElement !== null ? tapElement.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            money_version: moneyVersion !== undefined && moneyVersion !== null ? moneyVersion.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            action: action !== undefined && action !== null ? action.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see MoneyViewLoadEvent
 */
export var MoneyViewLoad = function (_a) {
    var moneyFlowToken = _a.moneyFlowToken, loadTimeMs = _a.loadTimeMs, moneyVersion = _a.moneyVersion;
    return ({
        name: "Money View Load",
        parameters: {
            cdf_entity: "Money",
            cdf_action: "View",
            money_flow_token: moneyFlowToken !== undefined && moneyFlowToken !== null ? moneyFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            load_time_ms: loadTimeMs !== undefined && loadTimeMs !== null ? loadTimeMs.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            money_version: moneyVersion !== undefined && moneyVersion !== null ? moneyVersion.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
